import { createMultiStyleConfigHelpers, defineStyle } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(['control', 'label', 'container']);

const SelectionFieldSetting = definePartsStyle({
  control: defineStyle({
    _disabled: {
      background: 'unset',
      _hover: {
        background: 'unset',
      },
    },
  }),
});

export const Radio = defineMultiStyleConfig({
  variants: {
    'selection-field-setting': SelectionFieldSetting,
  },
});
